export const FilterToolbarStyles = {
  checkBoxStyles: {},
  menuItemStyle: {
    borderBottom: '1px solid #E8E9E8',
    borderTop: '1px solid #E8E9E8',
    padding: '8px',
    color: 'brand.army-dark',
    fontWeight: '600',
    opacity: 0.8,
    fontSize: '10px',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
  },
  buttons: {
    cancel: {
      background: 'brand.lightGreen',
      color: 'brand-army-green',
      margin: '5px',
    },
    save: {
      background: 'brand.army-green',
      color: 'brand.white',
      margin: '5px',
    },
    clear: {
      color: 'brand.army-dark',
      '& svg *': { stroke: 'brand.grey-light' },
      fontSize: '13px',
    },
  },
  disabledMenuButton: {
    opacity: 0.4,
    cursor: 'not-allowed',
    boxShadow: 'none',
    background: 'brand.disabledBackground',
    color: 'brand.disabledText',
    border: 'none',
  },
  clearAllText: {
    fontSize: '11px',
    color: 'brand.tangerine.900',
    cursor: 'pointer',
  },
  clearAllContainer: {
    pt: (theme: any) => theme.space.eight,
  },
};
